import React from 'react'

const ServiceComponent = () => {
  return (
    <main>
      {/* Hero Area Start */}
      <div
        className="hero-area hero-height2 d-flex align-items-center"
        data-background="assets/img/hero/h2_hero.jpg"
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="hero-cap text-center pt-50">
                <h2>Service Kami</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Hero Area End */}
      {/* Our Services Start */}
      <div className="our-services section-padding2">
        <div className="container">
          <div className="row">
            <div className=" col-lg-4 col-md-6 col-sm-6">
              <div className="single-services text-center mb-30">
                <div className="services-ion">
                  <span className="fas fa-globe" />
                </div>
                <div className="services-cap mt-4">
                  <h5>Web Developer</h5>
                  <p>
                    Adalah Pengembang Web yang bekerja untuk merancang, membuat,
                    dan memelihara situs web dan aplikasi web.
                  </p>
                </div>
              </div>
            </div>
            <div className=" col-lg-4 col-md-6 col-sm-6">
              <div className="single-services text-center mb-30">
                <div className="services-ion">
                  <span className="fas fa-mobile-alt" />
                </div>
                <div className="services-cap mt-4">
                  <h5>Mobile Developer</h5>
                  <p>
                    Merupakan seorang programmer yang bisa membuat sebuah produk
                    berupa aplikasi dan dapat di tambahkan ke playstore.
                  </p>
                </div>
              </div>
            </div>
            <div className=" col-lg-4 col-md-6 col-sm-6">
              <div className="single-services text-center mb-30">
                <div className="services-ion">
                  <span className="fas fa-pencil-ruler" />
                </div>
                <div className="services-cap mt-4">
                  <h5>Design Ui / Ux</h5>
                  <p>
                    UI Designer memiliki tugas menentukan tampilan situs & UX
                    Designer menentukan bagaimana suatu situs bisa beroperasi.
                  </p>
                </div>
              </div>
            </div>
            <div className=" col-lg-4 col-md-6 col-sm-6">
              <div className="single-services text-center mb-30">
                <div className="services-ion">
                  <span className="fas fa-tasks" />
                </div>
                <div className="services-cap mt-4">
                  <h5>Project Management</h5>
                  <p>
                    adalah sebuah proses atau metode sebuah perusahaan dalam
                    menjalankan berbagai macam proyek dan acara.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Our Services End */}
      {/* Want To Work Start */}
      <div className="wantToWork-area wantToWork-area2 w-padding2">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-xl-8 col-lg-8 col-md-8">
              <div className="wantToWork-caption wantToWork-caption2">
                <h2>
                  Segera hubungi kami dan buat bisnis anda menjadi digital
                  dengan kami.
                </h2>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-4">
              <a href="/contact" className="btn btn-black f-right">
                contact us now
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* Want To Work End */}
    </main>
  )
}

export default ServiceComponent
